export default "__VITE_ASSET__BlHaxL7n__"